import { render, staticRenderFns } from "./DecisionDiamondTest.vue?vue&type=template&id=564b2b06&scoped=true"
import script from "./DecisionDiamondTest.vue?vue&type=script&lang=js"
export * from "./DecisionDiamondTest.vue?vue&type=script&lang=js"
import style0 from "./DecisionDiamondTest.vue?vue&type=style&index=0&id=564b2b06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564b2b06",
  null
  
)

export default component.exports